module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-badge', {
    staticStyle: {
      "font-size": "100%",
      "color": "blue"
    },
    on: {
      "click": function($event) {
        _vm.viewBRFDetails(_vm.booking_id, _vm.prbr_id)
      }
    }
  }, [_c('b', [_vm._v("View BRF Booking\n      Log")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": 'row' + _vm.booking_id
    }
  }, [_c('md-switch', {
    staticClass: "md-primary",
    attrs: {
      "id": 'approval' + _vm.booking_id,
      "name": "approval",
      "value": _vm.isbookingactive == 1
    },
    on: {
      "change": function($event) {
        _vm.toggleStatus(_vm.prbr_id, _vm.prbr_is_active, _vm.booking_id, _vm.isbookingactive, _vm.request_type)
      }
    }
  }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
    staticStyle: {
      "margin-left": "-45px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isbookingactive == 1 ? "Active" : "In-Active") + "\n        ")])], 1)])], 1), _vm._v(" "), _c('b-modal', {
    ref: "viewBRFDetails-modal",
    attrs: {
      "id": "viewBRFDetails-modal",
      "title": 'BRF Details-' + _vm.brf_no + ' Booking No -' + _vm.booking_no,
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-table', {
    attrs: {
      "items": _vm.BrfBookingList,
      "fields": _vm.BrfBookingColumn,
      "small": "",
      "responsive": "",
      "head-variant": "light"
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.item.SN))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right btn-sm mt-2",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.hideviewBRFDetails
    }
  }, [_vm._v("\n      Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40f25bc3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Pricing/ToggleBRFSwitch.vue
// module id = 2555
// module chunks = 0